{
  "overlay": {
    "viewArchive": {
      "title": "Baca arkib",
      "description": "Lihat edisi lalu di sini"
    },
    "startReading": {
      "title": "Mula Membaca",
      "description": "Baca edisi hari ini dengan butang ini"
    }
  },
  "tutorials": [
    {
      "title": "Cuba sekarang",
      "body": "Nikmati pengalaman pengguna yang lebih baik dengan akses pantas, arkib dan paparan artikel terperinci.  Ketahui lebih lanjut tentang ciri-ciri ini dalam tutorial"
    },
    {
      "title": "Paparan artikel terperinci",
      "body": "Klik untuk baca artikel penuh dengan lebih mudah. (Untuk pelanggan berbayar sahaja)"
    },
    {
      "title": "Baca edisi ePaper yang lepas",
      "body": "Akses edisi ePaper yang lepas di sini"
    },
    {
      "title": "Akses pantas ke semua halaman",
      "body": "Previu dan langsung ke halaman atau bahagian lain dengan pantas"
    },
    {
      "title": "Baca edisi ePaper yang lepas",
      "body": "Ikuti perkembangan terkini dengan baca laporan lepas yang tidak sempat dibaca sebelum ini"
    },
    {
      "title": "Muat turun imej",
      "body": "Simpan muka surat sebagai imej dalam peranti"
    },
    {
      "title": "Perkongsian artikel",
      "body": "Tekan ikon untuk kongsi pautan"
    },
    {
      "title": "Pilih paparan lain",
      "body": "Pilih untuk tukar paparan artikel dengan muka surat"
    }
  ]
}
